import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import useSources from "../../hooks/useSources";
import { useTranslation } from "../../hooks/useLocalization";
import useMessage from "../../hooks/useMessage";

import useAnalytics from "../../hooks/useAnalytics";

const DeleteSourceModal = ({ source, open, setOpen, onComplete }) => {
  const { t } = useTranslation();
  const { id } = source || {};
  const { CONSOLE_EVENTS } = useAnalytics();
  const { deleteSource } = useSources();
  const [isSubmitting, setSubmitting] = useState();
  const { showMessage, showMessageWithDebug } = useMessage();
  const onClose = async () => {
    setOpen(false);
    await CONSOLE_EVENTS.EV_DeleteSource.send({ action: 'close' })
  }
  return (
    <Modal show={open} onHide={onClose} enforceFocus={false}>
      <Helmet title={t("Delete Source")} />
      <Modal.Header closeButton>{t("Delete")}</Modal.Header>
      <Modal.Body className="text-center m-3">
        <p className="mb-0">{t("After deleting this source ...")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onClose()}>
          {t("Close")}
        </Button>{" "}
        <Button
          disabled={isSubmitting}
          variant="danger"
          onClick={async () => {
            try {
              setSubmitting(true);
              await deleteSource(id);
              showMessage({ save: t("The source was successfully deleted") });
              onComplete && onComplete(id);
              await CONSOLE_EVENTS.EV_DeleteSource.send({ action: 'delete', params: { sid: id } })
            } catch (error) {
              const { message = t("Something went wrong"), debug } = error;
              showMessageWithDebug({ error: message, debug });
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {t("Delete Source")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSourceModal;
